import { gql } from '@apollo/client';

const CREDENTIALS = `
  credentials {
    accessToken
    client
    expiry
    tokenType
    uid
  }
`;

export const ACCEPT_INVITATION = gql`
  mutation SellerUserUpdatePasswordWithToken(
    $password: String!
    $passwordConfirmation: String!
    $invitationToken: String!
  ) {
    sellerUserAcceptInvitation(
      password: $password
      passwordConfirmation: $passwordConfirmation
      invitationToken: $invitationToken
    ) {
      ${CREDENTIALS}
    }
  }
`;

export const LOGIN = gql`
  mutation Login(
    $email: String!
    $password: String!
  ) {
    sellerUserLogin(
      email: $email
      password: $password
    ) {
      ${CREDENTIALS}
    }
  }
`;

export const SEND_PASSWORD_RESET = gql`
  mutation SellerUserSendPasswordResetWithToken(
    $email: String!
  ) {
    sellerUserSendPasswordResetWithToken(
      email: $email
      redirectUrl: "https://equplinc.com"
    ) {
      message
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation SellerUserUpdatePasswordWithToken(
    $password: String!
    $passwordConfirmation: String!
    $resetPasswordToken: String!
  ) {
    sellerUserUpdatePasswordWithToken(
      password: $password
      passwordConfirmation: $passwordConfirmation
      resetPasswordToken: $resetPasswordToken
    ) {
      ${CREDENTIALS}
    }
  }
`;
